import { takeLatest, put, call } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';
import ReferralActionTypes from './types';
import {
  referralJoinSuccess,
  referralJoinFailure,
  referralLinkSuccess,
  referralLinkFailure,
  referralToasterHide,
} from './actions';
import UrlConfig from './urls';

const delay = (time: number) => new Promise((resolve) => setTimeout(resolve, time));

function* postReferralJoin(action: any) {
  const requestURL = UrlConfig.saveReferralJoin();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(referralJoinFailure(response?.data?.message || 'Something went wrong'));
    } else {
      yield put(referralJoinSuccess(response));
    }
  } catch (e) {
    yield put(referralJoinFailure(e));
    console.log({ e });
  }
}

function* getReferralLink(action: any) {
  const requestURL = UrlConfig.fetchReferralLink();
  try {
    const response = yield api.get(requestURL);
    yield put(referralLinkSuccess(response));
  } catch (e) {
    yield put(referralLinkFailure(e));
    console.log({ e });
  }
}

function* hideToaster() {
  yield call(delay, 3000);
  yield put(referralToasterHide());
}

function* referralSaga() {
  yield takeLatest(ReferralActionTypes.REFERRAL_JOIN_START, postReferralJoin);
  yield takeLatest(ReferralActionTypes.REFERRAL_LINK_START, getReferralLink);
  yield takeLatest(ReferralActionTypes.REFERRAL_TOASTER_SHOW, hideToaster);
}

export default referralSaga;
